(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 64406:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(66091);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ LoginForm; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/hooks/dist/index.js + 24 modules
var dist = __webpack_require__(4495);
// EXTERNAL MODULE: ../../packages/components/dist/index.js
var components_dist = __webpack_require__(76303);
// EXTERNAL MODULE: ../../packages/error-codes/dist/index.js
var error_codes_dist = __webpack_require__(15564);
// EXTERNAL MODULE: ../../node_modules/firebase/app/dist/index.esm.js
var index_esm = __webpack_require__(35532);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63397);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(24511);
// EXTERNAL MODULE: ./components/functional/social-sign-on/index.tsx + 1 modules
var social_sign_on = __webpack_require__(9934);
;// CONCATENATED MODULE: ./components/functional/login-form/login-form.tsx









const LoginForm = (param)=>{
    let { onSuccess , onError , children  } = param;
    const { analytics  } = (0,dist/* useAnalytics */.z$)();
    const [submitError, setSubmitError] = (0,react.useState)();
    const { handleSubmit , handleChange , values , errors , isSubmitting  } = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema: es/* object */.Ry().shape({
            email: es/* string */.Z_().email().required(),
            password: es/* string */.Z_().required()
        }),
        onReset () {
            setSubmitError(undefined);
        },
        async onSubmit (values) {
            try {
                // Dynamically import firebase. This is a heavy package and thus this saves us
                // from importing unnecessarily
                const { getAuth , signInWithEmailAndPassword  } = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 70971));
                // Sign in with email and password
                const signInResult = await signInWithEmailAndPassword(getAuth(), values.email, values.password);
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                // if no error, will continue past if statement
                analytics.identify(signInResult.user.uid, {
                    ...signInResult.user
                });
            // segment.login("email/password", values.email);
            } catch (error) {
                if (error instanceof index_esm.FirebaseError) {
                    onError === null || onError === void 0 ? void 0 : onError(error);
                    var _message;
                    setSubmitError((_message = error_codes_dist/* firebaseCodeErrorsMap.get */.Fq.get(error.code).message) !== null && _message !== void 0 ? _message : "Unable to process log in request");
                } else {
                    throw error;
                }
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(social_sign_on/* SocialSignOn */._, {
                text: "Continue",
                onError: (msg)=>{}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_dist/* Input */.II, {
                        id: "email",
                        placeholder: "Email",
                        type: "email",
                        name: "email",
                        autoComplete: "email",
                        value: values.email,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_dist/* Input */.II, {
                        id: "password",
                        type: "password",
                        placeholder: "Password",
                        name: "password",
                        autoComplete: "current-password",
                        value: values.password,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_dist/* PrimaryBtn */.f6, {
                        type: "submit",
                        loading: isSubmitting,
                        disabled: isSubmitting,
                        children: "Log In"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/functional/login-form/index.tsx



/***/ }),

/***/ 63370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ SEO; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../packages/content/dist/index.js
var dist = __webpack_require__(63521);
;// CONCATENATED MODULE: ./components/functional/seo/seo.tsx




const SEO = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const title = "".concat((ref = props.page) === null || ref === void 0 ? void 0 : ref.title, " | NuCalm");
    const sanityImageUrl = ((ref1 = props.page) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.asset) ? (0,dist.urlFor)((ref3 = props.page) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.asset).width(1200).height(600).url() : "https://firebasestorage.googleapis.com/v0/b/nucalmv3-dev.appspot.com/o/Mastermind%2FIgniteScreen.png?alt=media&token=1fd39db7-f560-445e-9c8d-09597cd8de5b";
    const origin =  true ? window.location.origin : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }),
            ((ref5 = props.page) === null || ref5 === void 0 ? void 0 : ref5.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: props.page.description
            }),
            props.noindex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            props.path && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: "".concat(origin).concat(props.path)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            ((ref6 = props.page) === null || ref6 === void 0 ? void 0 : ref6.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: (ref7 = props.page) === null || ref7 === void 0 ? void 0 : ref7.description
            }),
            sanityImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: sanityImageUrl
            }),
            props.imgUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: props.imgUrl
            }),
            props.path && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:url",
                content: "".concat(origin).concat(props.path)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            ((ref8 = props.page) === null || ref8 === void 0 ? void 0 : ref8.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: props.page.description
            }),
            sanityImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:image",
                content: sanityImageUrl
            }),
            props.imgUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:image",
                content: props.imgUrl
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/functional/seo/index.tsx



/***/ }),

/***/ 28638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ queryToString; }
/* harmony export */ });
/* unused harmony export queryToParams */
const queryToString = (query)=>{
    const params = queryToParams(query);
    return params.toString();
};
const queryToParams = (query)=>{
    const params = new URLSearchParams();
    Object.keys(query).forEach((key)=>{
        const value = query[key];
        if (Array.isArray(value)) {
            value.forEach((val)=>params.append(key, val));
        } else {
            params.set(key, value);
        }
    });
    return params;
};


/***/ }),

/***/ 66091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _functional_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63370);
/* harmony import */ var _libs_constants_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69463);
/* harmony import */ var _libs_middleware_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28638);
/* harmony import */ var _ui_app_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81041);
/* harmony import */ var _blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1300);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _functional_login_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51616);
/* harmony import */ var next_firebase_auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78868);
/* harmony import */ var next_firebase_auth__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_firebase_auth__WEBPACK_IMPORTED_MODULE_7__);










const Login = (props)=>{
    var ref;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const params = new URLSearchParams((0,_libs_middleware_query__WEBPACK_IMPORTED_MODULE_8__/* .queryToString */ .W)(router.query));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_app_layout__WEBPACK_IMPORTED_MODULE_3__/* .AppLayout */ .L, {
        className: "bg-gray-900",
        menus: (ref = props.site) === null || ref === void 0 ? void 0 : ref.menus,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_functional_seo__WEBPACK_IMPORTED_MODULE_1__/* .SEO */ .H, {
                    path: _libs_constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .routes.LOGIN */ ._j.LOGIN,
                    page: {
                        title: "Log In",
                        description: ""
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: " py-6 md:py-8 ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "wrapper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "max-w-sm mx-auto md:py-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_functional_login_form__WEBPACK_IMPORTED_MODULE_6__/* .LoginForm */ .U, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__.H4, {
                                            className: "font-normal text-primary-100",
                                            children: "Welcome back."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__.H1, {
                                            className: "text-primary-100",
                                            children: "Login"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__.H6, {
                                            className: "font-normal text-primary-100",
                                            children: [
                                                "New here?",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    href: _libs_constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .routes.SIGNUP */ ._j.SIGNUP + "?" + params.toString(),
                                                    className: "font-bold text-primary-100 hover:text-secondary-500",
                                                    children: "Sign Up"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_firebase_auth__WEBPACK_IMPORTED_MODULE_7__.withAuthUser)({
    whenUnauthedAfterInit: next_firebase_auth__WEBPACK_IMPORTED_MODULE_7__.AuthAction.RENDER,
    whenAuthedBeforeRedirect: next_firebase_auth__WEBPACK_IMPORTED_MODULE_7__.AuthAction.RENDER,
    whenAuthed: next_firebase_auth__WEBPACK_IMPORTED_MODULE_7__.AuthAction.REDIRECT_TO_APP
})(Login));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4785,7544,4511,1931,3596,9774,2888,179], function() { return __webpack_exec__(64406); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);